import qs from 'qs';

import { appEnv } from '@/app/config/env';
import { storageKeys } from '@/app/constants/storageKeys';
import { storage } from '@/infra/protocols/storage';

/**
 * Clean storage and redirect user to oauth login page
 */
function redirectToAuth() {
  storage.clearExcept(storageKeys.REDIRECT_AFTER_AUTH);

  location.assign(
    `${appEnv.authUrl}?${qs.stringify({
      scope: 'openid email profile',
      client_id: appEnv.authClientId,
      response_type: 'code',
      redirect_uri: getAuthRedirectUri(),
    })}`,
  );
}

function getAuthRedirectUri() {
  return `${location.origin}${'/auth'}`;
}

/**
 * Clean storage and redirect user to oauth logout page
 */
function redirectToLogout() {
  storage.clear();

  location.assign(
    `${appEnv.logoutUrl}?${qs.stringify({
      client_id: appEnv.authClientId,
      redirect_uri: getAuthRedirectUri(),
    })}`,
  );
}

export { getAuthRedirectUri, redirectToAuth, redirectToLogout };
